import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { Tooltip } from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'


const FilterIndicatorBox: React.FC<{ text?: string; groups?: string[] | null }> = ({ text = "Filtered", groups }) => {
  const theme = useTheme();
  return (
    <Tooltip title={groups?.join(" > ")}>
      <Box
        sx={{
          display: "inline",
          alignItems: 'center',
          gap: '2px',
          padding: '0px 6px',
          borderRadius: '6px',
          border: `1px solid ${theme.border}`,
          fontSize: '14px',
          color: theme.buttonBackground,
          backgroundColor: 'blue',
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
}

export default FilterIndicatorBox;
